import {
  AdminDatePickerModal,
  Button,
  Div,
  HeaderIconWrapper,
  ModalPortal,
  P,
  PlusIcon,
  PropsModal,
  SuccessToast,
  createClosingDay,
  isAdmin,
  reportError,
} from '@vgrubs/components';
import { ApplyToType } from 'components/src/types/location.types';
import { DateTime } from 'luxon';
import { Dispatch, SetStateAction, useState } from 'react';

export const AddClosingDays = ({
  closeModal,
  setLoading,
  locationId,
  brandId,
  handleAddSubmit,
}: PropsModal & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  locationId: number;
  brandId: number | null;
  handleAddSubmit: () => void;
}) => {
  const [date, setDate] = useState<Date[]>([]);
  const [applyToAll, setApplyToAll] = useState(false);

  async function handleAddClosingDay(applyTo?: ApplyToType) {
    if (!date[0]) return;
    const from = DateTime.fromJSDate(date[0]).toISODate() as string;
    const to = DateTime.fromJSDate(date[1] || date[0]).toISODate() as string;

    try {
      const closingDay = {
        locationId,
        brandId: isAdmin ? brandId : undefined,
        from,
        to,
        applyTo,
      };

      setLoading(true);
      const { data } = await createClosingDay(closingDay);
      SuccessToast(data.message);
      closeModal?.();
      setDate([]);
      handleAddSubmit();
      setApplyToAll(false);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  const handleSubmit = (applyToAll: boolean) => {
    if (brandId !== null) {
      if (applyToAll) {
        handleAddClosingDay(ApplyToType.all_brands);
      } else {
        handleAddClosingDay(ApplyToType.brand_only);
      }
    } else {
      if (applyToAll) {
        handleAddClosingDay(ApplyToType.location_and_all_brands);
      } else {
        handleAddClosingDay(ApplyToType.location_only);
      }
    }
  }

  return (
    <>
      <AdminDatePickerModal
        value={date}
        onChange={(d) => setDate(d as Date[])}
        click={() => isAdmin ? setApplyToAll(true) : handleAddClosingDay()}
        header="Add Closing Days"
        dateFormat="Y-m-d"
        triggerComponent={
          <HeaderIconWrapper $opened={false}>
            <PlusIcon />
          </HeaderIconWrapper>
        }
        minDate="today"
        maxDate="2100-01-01"
      />
      <ApplyToAll isOpen={applyToAll} setIsOpen={setApplyToAll} handleSubmit={handleSubmit} />
    </>
  );
};


export const ApplyToAll = ({
  isOpen,
  setIsOpen,
  handleSubmit,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleSubmit: (applyToAll: boolean) => void;
}) => {
  return (
    <ModalPortal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      overflow="visible"
      zIndex={131}
    >
      <Div $flex $column $alignCenter $gap="16px">
        <P $m="0" $center $maxWidth="300px">
          Do you want to apply this closing day to all brands connected to this location?
        </P>
      </Div>
      <Div $flex $center $mt="24" $gap="16px">
        <Button $w="100%" $selected onClick={() => handleSubmit(true)}>
          Yes
        </Button>
        <Button $w="100%" $selected $gray onClick={() => handleSubmit(false)}>
          No
        </Button>
      </Div>
    </ModalPortal>
  );
};
